import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const secondaryButtonStyle = {
    background: colorSystem.neutral.white,
    color: colorSystem.neutral[7],
    border: `1px solid ${colorSystem.neutral[3]}`,
    '&:hover': {
        background: colorSystem.primary[1],
        color: colorSystem.primary[7],
        border: `1px solid ${colorSystem.primary[3]}`,
    },
    '&:active': {
        background: colorSystem.primary[2],
        color: colorSystem.primary[7],
        border: `1px solid ${colorSystem.primary[3]}`,
    },
    '&:disabled': {
        background: colorSystem.neutral.white,
        color: colorSystem.neutral[5],
        border: `1px solid ${colorSystem.neutral[4]}`,
    },
};

const SecondaryButtonHost = styled(BaseButton)(secondaryButtonStyle);
const SecondaryButtonLinkHost = styled(LinkButton)(secondaryButtonStyle);

export const SecondaryButton = linkable(SecondaryButtonHost, { linkHost: SecondaryButtonLinkHost });
